import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/phone.png'


const _hoisted_1 = { class: "officersdetail" }
const _hoisted_2 = { class: "top-content flex-n fac" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info-text" }
const _hoisted_10 = ["href"]

import {onMounted,ref} from "vue";
import userApi from "@/utils/Api/User";
import {useRoute} from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'officersdetail',
  setup(__props) {

onMounted(()=>{
  document.title='人员详情页面';
  getData();
})
const route=useRoute();
const info=ref({});
const getData=()=>{
  userApi.detail(route.query.id).then(res=>{
    console.log(res)
    info.value=res.data;
  })
}
const onClickLeft=()=>{
  history.back();
}

const getPractisingAge=(industrytime:string)=>{
  console.log(1)
  if(industrytime){
    const date1=new Date(industrytime),date2=new Date();
    let y1=date1.getFullYear(),m1=date1.getMonth()+1,d1=date1.getDate(),
        y2=date2.getFullYear(),m2=date2.getMonth()+1,d2=date2.getDate();
    console.log(y1,y2,m1,m2,d1,d2)
    if(y1>y2){
      //输入有误
      return ''
    }else{
      if(m2>m1||m2==m1&&d2>=d1){
        return  y2-y1<1?'不足一年':(y2-y1+'年');
      }else{
        return y2-y1-1<1?'不足一年':(y2-y1-1+'年');
      }
    }
  }else{
    return ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        title: "人员详情页面",
        "left-arrow": "",
        fixed: "",
        placeholder: "",
        onClickLeft: onClickLeft
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: info.value.userimg
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(info.value.username), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(info.value.companyName), 1),
          _createElementVNode("div", _hoisted_7, "从业时间：" + _toDisplayString(getPractisingAge(info.value.industrytime)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "info-title" }, "服务详情", -1)),
        _createElementVNode("div", _hoisted_9, _toDisplayString(info.value.userdesc), 1)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"5.9rem"} }, null, -1)),
    _createElementVNode("a", {
      class: "phone",
      href: 'tel:'+info.value.telephone
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1),
      _createElementVNode("div", null, "电话", -1)
    ]), 8, _hoisted_10)
  ], 64))
}
}

})